import { useInfiniteQuery } from '@tanstack/react-query'

import { getPointHistory } from 'lib/api/point/getPointHistory'

const useGetPointHistoryQuery = ({ lastPosNo, limit }, options) => {
  return useInfiniteQuery(
    ['getPointHistory', lastPosNo, limit],
    // pageParam의 초기값으로 undefined가 사용됨. 그 후로는 getNextPageParam이 반환하는 값이 사용됨
    ({ pageParam }) => getPointHistory({ lastPosNo: pageParam, limit }),
    {
      getNextPageParam: (lastPage) => {
        const { points: pointRecords } = lastPage.data
        return pointRecords.length > 0 ? pointRecords.at(-1).no : undefined
      },
      ...options,
    },
  )
}

export default useGetPointHistoryQuery
